export function routing($stateProvider) {
  $stateProvider.state('index.customercare.customer.configureAutopay', {
    url: '/configureAutopay',
    template: '<customer-configure-autopay></customer-configure-autopay>'
  });
}